import { Session } from "@equiem/web-ng-lib";
import React, { useContext, useEffect } from "react";
import {
  useEventPostEntityViewMetricMutation,
  useInfoPostEntityViewMetricMutation,
  useNewsPostEntityViewMetricMutation,
} from "../../generated/gateway-client";
import { ContentType } from "../../lib/ContentType";

interface Props {
  uuid: string;
  entityType: ContentType;
}

export const CortexEntityViewMetric: React.FC<Props> = ({ uuid, entityType }) => {
  const session = useContext(Session);

  const [newsPostEntityViewMetricMutation] = useNewsPostEntityViewMetricMutation();
  const [eventsPostEntityViewMetricMutation] = useEventPostEntityViewMetricMutation();
  const [infoPostEntityViewMetricMutation] = useInfoPostEntityViewMetricMutation();

  useEffect(() => {
    if (session.side !== "client" ) {
      return;
    }

    let entityViewMetricCallback;

    switch(entityType) {
      case ContentType.BuildingInfoPost:
        entityViewMetricCallback = infoPostEntityViewMetricMutation;
        break;

      case ContentType.NewsPost:
        entityViewMetricCallback = newsPostEntityViewMetricMutation;
        break;

      case ContentType.EventPost:
        entityViewMetricCallback = eventsPostEntityViewMetricMutation;
        break;

      default:
        return;
    }

    entityViewMetricCallback({
      variables: {
        entityViewInput: {
          contentUuid: uuid,
          timestamp: new Date().getTime(),
        },
      },
    }).catch((e: any) => {
      console.log("entity view metric send failed", e);
    });
  }, []);

  return (
    <>
    </>
  );
}
